import { useAtomValue } from "jotai";
import { videoSDKAdapterAtom } from "../core/atoms";

export function useLocalVideoComponent() {
  const adapter = useAtomValue(videoSDKAdapterAtom);
  return adapter.VideoComponents.LocalVideo;
}

export function useRemoteVideoComponent() {
  const adapter = useAtomValue(videoSDKAdapterAtom);
  return adapter.VideoComponents.RemoteAudioVideo;
}
